var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policies-title"},[_vm._v(_vm._s(_vm.$t('PatchEasy.PatchPolicy.title')))]),_vm._v(" "),_c('div',{staticClass:"policies-top"},[_c('policies-search')],1),_vm._v(" "),_c('table-policies')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39c14c06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/patch_management/policy/Policies.vue
// module id = sPNA
// module chunks = 0